(ns nosco.ui.avatar
  (:require
   ["react" :as React]
   [hx.react :refer [defnc]]
   [nosco.colors :as colors]
   [nosco.icons2 :as icons]
   [nosco.images :as images]
   [nosco.ui.text :as text]
   [nosco.ui.tooltips :as tooltips]))

(defnc Avatar
  "Avatar for a USER GraphQL object.

  Required User keys:
  - id
  - image
  - givenName
  - familyName"
  [{:keys [user size icon inline outline]}]
  (let [href (:href user)
        el (if href :a :div)]
    [el {:class ["nosco-avatar"
                 (when inline "d-inline-block")
                 (when (= :xsm size) "nosco-avatar--xsm")
                 (when (= :sm size) "nosco-avatar--sm")
                 (when (= :default size) "nosco-avatar--default")
                 (when (= :lg size) "nosco-avatar--lg")
                 (when (= :xlg size) "nosco-avatar--xlg")
                 (when (= :xxlg size) "nosco-avatar--xxlg")
                 (when outline "nosco-avatar--has-outline")]
         :href href
         :style (when (number? size) {:width size :height size})}
     (if (and (:image user) (not= (:image user) "/img/thumb-undefined.png"))
       [:img
        {:class ["nosco-avatar__image"]
         :src (images/thumbnail-url (:image user))
         #_#_:on-load #(.. % -target -classList (add "nosco-avatar__image--loaded"))}]
       [:div
        {:class ["nosco-avatar__initials"]
         :style {:background-color (colors/data-color-for (:id user))}}
        (first (:givenName user))
        (when (and (not= :xsm size) (not= :sm size))
          (first (:familyName user)))])
     (when icon
       [:div {:class "nosco-avatar__icon"}
        [icons/Icon {:icon icon
                     :color colors/white}]])]))

(defnc AvatarOverflow [{:keys [user size icon inline outline overflow-count]}]
  (let [href (:href user)
        el (if href :a :div)]
    [el {:class ["nosco-avatar"
                 (when inline "d-inline-block")
                 (when (= :xsm size) "nosco-avatar--xsm")
                 (when (= :sm size) "nosco-avatar--sm")
                 (when (= :default size) "nosco-avatar--default")
                 (when (= :lg size) "nosco-avatar--lg")
                 (when (= :xlg size) "nosco-avatar--xlg")
                 (when (= :xxlg size) "nosco-avatar--xxlg")
                 (when outline "nosco-avatar--has-outline")]
         :href href
         :style (when (number? size) {:width size :height size})}
     [:div
      {:class ["nosco-avatar__overflow"]}
      [text/Text {:variant text/Body-Sm-Regular}
       (str "+" overflow-count)]]]))

(defnc IconAvatar [{:keys [icon href size]}]
  (let [el (if href :a :div)]
    [el {:class ["nosco-avatar"
                 (when (= :xsm size) "nosco-avatar--xsm")
                 (when (= :sm size) "nosco-avatar--sm")
                 (when (= :default size) "nosco-avatar--default")
                 (when (= :lg size) "nosco-avatar--lg")]
         :href href}
     [:div
      {:class ["nosco-avatar__initials"]
       :style {:background-color colors/neutral-100}}
      [icons/Icon {:icon icon
                   :color colors/neutral-400}]]]))

(defnc IconAvatarColoredBackground [{:keys [icon href size color]}]
  (let [el (if href :a :div)]
    [el {:class ["nosco-avatar"
                 (when (= :xsm size) "nosco-avatar--xsm")
                 (when (= :sm size) "nosco-avatar--sm")
                 (when (= :default size) "nosco-avatar--default")
                 (when (= :lg size) "nosco-avatar--lg")]
         :href href}
     [:div
      {:class ["nosco-avatar__initials"]
       :style {:background-color color}}
      [icons/Icon {:icon icon
                   :color colors/white}]]]))

(defnc AvatarGroup [{:keys [users size total-count] :or {size :xsm}} ref]
  {:wrap [(React/forwardRef)]}
  (let [overflow-count (- total-count (count users))]
    [:div {:ref ref :class ["nosco-avatar-group"]}
     (for [user users]
       [Avatar {:user user :size size :outline true}])
     (when (pos? overflow-count)
       [AvatarOverflow {:size size
                        :outline true
                        :overflow-count overflow-count}])]))

(defnc Badge [{:keys [icon tooltip]}]
  [tooltips/WithTooltip {:label tooltip}
   [:div {:class "nosco-avatar__badge"}
    [icons/Icon {:icon icon
                 :color colors/white
                 :icon-style {:width "8px"
                              :height "8px"}}]]])

(defnc GroupAvatar
  "An avatar for a group of people.

Props:

- seed - a value used to choose a consistent background color"
  [{:keys [seed size inline outline href]}]
  (let [el (if href :a :div)
        color (colors/data-color-for seed)]
    [el {:class ["nosco-avatar"
                 (when inline "d-inline-block")
                 (when (= :xsm size) "nosco-avatar--xsm")
                 (when (= :sm size) "nosco-avatar--sm")
                 (when (= :default size) "nosco-avatar--default")
                 (when (= :lg size) "nosco-avatar--lg")
                 (when (= :xlg size) "nosco-avatar--xlg")
                 (when (= :xxlg size) "nosco-avatar--xxlg")
                 (when outline "nosco-avatar--has-outline")]
         :href href
         :style (when (number? size) {:width size :height size})}
     [:span {:class "nosco-avatar__group-icon"
             :style {:background-color color}}
      [icons/Icon
       {:icon icons/Team-small
        :icon-style {:width "100%"
                     :height "100%"
                     :fill colors/white}}]]]))
